module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../../node_modules/happypack/loader.js?id=jsx!./CouponTransferView.js"));
	}, "CouponTransferView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=CouponTransferView!./src/pages/Shop/Member/Wallet/Coupon/CouponTransfer/CouponTransferView.js
// module id = 1097
// module chunks = 431